import { useMutation } from "@tanstack/react-query";
import { postLogout, LogoutResponse } from "~/services/gateways/auth.gateway";
import { useNavigate } from "react-router";
import { clearTelemetryUser } from "~/telemetry";

export const useAuth = () => {
  const navigate = useNavigate();

  const logoutMutation = useMutation<LogoutResponse, Error>({
    mutationFn: postLogout,
    onSuccess: () => {
      clearTelemetryUser();
      navigate("/login", { replace: true, state: { fromLogout: true } });
    },
    onError: (error) => {
      console.error("ERRO LOGOUT:", error);
      clearTelemetryUser();
      navigate("/login", { replace: true, state: { fromLogout: true } });
    },
  });

  return {
    logoutMutation,
  };
};
